module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='asset-filters'></div>\n<div class='assets-frame js-assets-frame'>\n  <div class='assets-container js-assets-container'></div>\n  <div class='js-loading-mask'></div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/media_library_assets_layout.js.hamlc
// module id = 1545
// module chunks = 18